const Position = {
  /*soccers:{
    goalkeeper:["GK"],
    defender:["CB","LCB","RCB","LB","RB"],
    midfielder:["CM","LDM","RDM","CDM","CAM","LM","RM"],
    forward:["ST","CF","LW","RW"]
  },*/
  soccer:[
    "Goalkeeper",
    "Defender",
    "Midfielder",
    "Forward"
  ],
  rugby:[

  ],
}

export default Position;


// WEBPACK FOOTER //
// ./src/components/Positions.js